/**
 * Staff grades — the seniority band every staff_designation option carries
 * (Settings → Dropdown Lists → Staff Designation → Grade).
 *
 * One table for who may stand where:
 *   - LEAD_GRADE: the engagement person fields. Partner in Charge lists the
 *     Partner grade, Director(s) the Director grade, Manager(s) in
 *     Charge the Manager grade; Team Member(s) takes every grade.
 *   - REVIEWER_GRADE: the chosen-reviewer roster of the engagement-record
 *     flows (Partner / Director).
 *   - MASTER_REVIEWER_DEPARTMENT: the second chosen-reviewer roster — the
 *     master-data flows (New Client, Client Amendment, Engagement
 *     Registration, Engagement Amendment) take one Partner, or the QM Team:
 *     anyone serving in this department at review time, whatever their grade.
 *   - REPORT_BAND: the Official Training Report's five columns — the paper has
 *     no Director column, so Director counts under Manager there.
 *
 * The dropdown feeds, the server-side eligibility checks and the reviewer
 * roster all read this file, so a list and its validation cannot drift.
 *
 * CommonJS on purpose: the API require()s it and the React build imports it.
 */

// Seniority order, highest first. Settings offers these and nothing else.
const STAFF_GRADES = [
  'Partner',
  'Director',
  'Manager',
  'Assistant Manager',
  'Senior',
  'Assistant',
  'Other',
];

const LEAD_GRADE = {
  partner: 'Partner',
  director: 'Director',
  manager: 'Manager',
};

const REVIEWER_GRADE = {
  partner: 'Partner',
  director: 'Director',
};

// The Staff Department option whose members sit on the master-data reviewer
// roster. Settings refuses to rename, deactivate or delete it.
const MASTER_REVIEWER_DEPARTMENT = 'QM';

// The QM Team as a reviewer pick: the value the reviewer select posts in
// reviewerStaffId, the value stored in <table>.reviewer_team, and the name the
// request shows.
const QM_TEAM_PICK = 'team:qm';
const QM_TEAM = 'qm';
const QM_TEAM_NAME = 'QM Team';

// Official Training Report columns, in the paper's order. 'Other' is excluded.
const REPORT_GRADES = [
  'Partner',
  'Manager',
  'Assistant Manager',
  'Senior',
  'Assistant',
];

// Grade → report column (identity unless listed).
const REPORT_BAND_OF = { 'Director': 'Manager' };
const reportBandOf = (grade) => (grade && REPORT_BAND_OF[grade]) || grade || null;

module.exports = {
  STAFF_GRADES, LEAD_GRADE, REVIEWER_GRADE, MASTER_REVIEWER_DEPARTMENT, QM_TEAM_PICK, QM_TEAM, QM_TEAM_NAME, REPORT_GRADES, REPORT_BAND_OF, reportBandOf,
};
